import React from 'react';
import Icon from '../../common/Icon/Icon';

/**
 * Form Input component with icon and label
 * @param {string} label - Input label
 * @param {string} icon - Icon name for left icon
 * @param {string} type - Input type (text, email, tel, etc.)
 * @param {string} placeholder - Placeholder text
 * @param {string} value - Input value
 * @param {function} onChange - Change handler
 * @param {boolean} required - Whether input is required
 * @param {string} error - Error message
 */
const Input = ({
  label,
  icon,
  type = 'text',
  placeholder,
  value,
  onChange,
  required = false,
  error,
  className = '',
  ...props
}) => {
  return (
    <div className={`space-y-2 group ${className}`}>
      {label && (
        <label className="form-label">
          {label}
          {required && <span className="text-red-400 ml-1">*</span>}
        </label>
      )}
      <div className="relative">
        <input
          type={type}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          required={required}
          className={`
            form-input
            ${icon ? 'pl-12' : 'pl-4'}
            ${error ? 'border-red-500 focus:ring-red-500' : ''}
          `}
          {...props}
        />
        {icon && (
          <Icon
            name={icon}
            className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-500 group-focus-within:text-primary transition-colors"
          />
        )}
      </div>
      {error && (
        <p className="text-red-400 text-xs ml-1">{error}</p>
      )}
    </div>
  );
};

export default Input;
